<template>
	<div class="single_question">
		<div class="question_title">
			<span>{{questionData.sectionName === undefined ? "" : questionData.sectionName}}</span>
			<span>({{questionData.sectionPrompt+" 本题"+questionData.score+"分。"}})</span>
		</div>
		<div class="title">
			<div v-if="questionData.questionContent" class=" editorShowArea ql-editor title_one" v-html="questionData.questionContent">
			</div>
			<h1 style="overflow: auto;" class=" editorShowArea ql-editor" v-html="questionData.questionDto.questionContent"></h1>
		</div>
		<div class="single_item" v-for="(data,index) in questionData.questionDto.items" :key="index">
			<el-radio @change="save" class="single_radio" v-model="radio" :label="data.itemKey" :disabled="disabledFlag">{{null}}</el-radio>
			<span style="float: left;margin-top:15px;" class="single_title">{{data.itemKey}}</span>
			<span class="single_title ql-editor" v-html="data.itemValue"></span>
		</div>
	</div>

</template>

<script>
	import {
		moduleId
	} from "../../../../../store/modules/exam";
	import {
		mapState,
		mapMutations,
		mapActions,
		mapGetters
	} from 'vuex';
	export default {
		name: "single",
		data() {
			return {
				radio: '',
				disabledFlag: true
			};
		},
		computed: {
			...mapState(moduleId, {
				questionData: state => state.questionData,
				paperData: state => state.paperData,
				preAnswer: state => state.preAnswer,
			}),
		},
		watch: {
			//显示上次选择的答案
			preAnswer(newVal) {
				console.log(newVal)
				this.radio = ''
				if (newVal !== null) {
					this.radio = newVal.answer;
					this.disabledFlag = false
				}else{
					this.disabledFlag = true
				}
			},
		},
		methods: {
			...mapActions(moduleId, ['saveAnswerNew']),
			save() {
				let obj = {
					"examPaperId": this.paperData.examPaperId,
					"subjectId": localStorage.getItem("subjectId"),
					"classId": this.$route.query.classId,
					"courseId": this.$route.query.id,
					"paperCode": this.$route.query.paperCode,
					"paperId": this.$route.query.paperId,
					"questionId": this.questionData.questionId,
					"questionType": 1,
					"version": 1,
					"userAnswer": this.radio,
					"score": this.questionData.score,
					"questionStatus": 0,
					"useTime": "23",
					"type": this.$route.query.type
				};
				this.saveAnswerNew(obj);
			}
		},
		mounted() {
			console.log(this.questionData.questionDto)
		}
	}
</script>

<style lang="scss" scoped>
	.single_question {

		// background: white;
		// height: 100%;
		.question_title {
			width: 97%;
			margin-left: 30px;
			padding-top: 30px;
			padding-bottom: 30px;
			border-bottom: 1px solid #BBCEF6;

			span:nth-child(1) {
				font-size: 18px;
				font-weight: bold;
			}

			span:nth-child(2) {
				font-size: 12px;
				font-weight: 500;
				margin-left: 12px;
			}
		}

		.title {
			.title_one {
				width: 95%;
				margin: auto;
			}

			.ql-editor {
				max-width: 98%;
				overflow: auto !important;
				margin: auto;
				font-size: 16px;
			}

			/deep/ .ql-editor img {
				max-width: 100% !important;
			}
		}

		.single_item {
			margin-left: 50px;
			display: block;

			.single_radio {
				float: left;
				margin-top: 14px;
				margin-right: 5px !important;
			}

			/deep/ .single_title {
				display: inline-block;
				margin-left: 10px;

				p {
					width: 100%;

					img {
						width: 100%;
					}
				}
			}
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/views/studyCenter/switch/testSumulationComponentNew/single.vue